export default __webpack_public_path__ + "static/media/NeueBestellung.30e8d23d.jpg";